import { createSlice } from "@reduxjs/toolkit";

interface MilestoneSchedule {
  acquisition: string;
  construction: string;
  designAndEntitlements: string;
  financialClose: string;
  projectCompletion: string;
  siteControl: string;
}

const initialState: MilestoneSchedule = {
  acquisition: "",
  construction: "",
  designAndEntitlements: "",
  financialClose: "",
  projectCompletion: "",
  siteControl: "",
};

const MilestoneScheduleSlice = createSlice({
  name: "milestoneSchedule",
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { set } = MilestoneScheduleSlice.actions;
export default MilestoneScheduleSlice.reducer;
